import SelectValueContainer from './SelectValueContainer';

export default SelectValueContainer;
